export default __webpack_public_path__ + "static/media/newsletterpart.002ee84c.webp";